import { Subject } from "rxjs";
export var staticPagesList = [];
export var announcementsList = [];
export var teamList = [];
export var helpList = [];
export var allsportsList = [];
export var sliderMap = {};
export var sliderMapSubject = new Subject();
